import {SPECIAL_SYMBOL_NAMES} from "../server/IKMDData";
import {KennethMustDie} from "../KennethMustDie";
import {KMDGameMode} from "../server/KMDGameMode";

export class KMDSpinSymbol extends PIXI.Sprite {

    constructor(symbolName: string) {
        super();

        if (symbolName === SPECIAL_SYMBOL_NAMES.NW) {
            symbolName = SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD;
        }

        this.texture = this.getAssetName(symbolName);
        this.anchor.set(0.5);
    }

    private getAssetName(symbolName: string): PIXI.Texture {
        const mode: string = KennethMustDie.mode,
            blur: string = "_vertical_blur";
        let textureName: string = "",
            nameHelper: string = "mg";

        if (mode === KMDGameMode.FREESPIN || mode === KMDGameMode.FREESPIN_AVALANCHE || mode === KMDGameMode.FREESPIN_COOL || mode === KMDGameMode.FREESPIN_COOL_AVALANCHE) {
            nameHelper = "fs";
        } else if (mode === KMDGameMode.FREESPIN_SUPER || mode === KMDGameMode.FREESPIN_SUPER_AVALANCHE) {
            nameHelper = "sipia";
        }

        if (symbolName === SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD) {
            textureName = ("XNudgeWild/XNudgeWild_Assets/nudge" + blur);
        } else if (symbolName === SPECIAL_SYMBOL_NAMES.W) {
            textureName = symbolName + "/wild" + blur;
        } else if (symbolName === SPECIAL_SYMBOL_NAMES.S2) {
            textureName = symbolName + "/S2_Assets/s2_blur";
        } else if (symbolName === SPECIAL_SYMBOL_NAMES.S) {
            textureName = symbolName + "/S_Assets/s1_blur";
        } else if (symbolName === SPECIAL_SYMBOL_NAMES.SM1) {
            textureName = "M1/S_M1_Assets/S_M1" + blur;
        } else if (symbolName === SPECIAL_SYMBOL_NAMES.SM2) {
            textureName = "M2/S_M2_Assets/S_M2" + blur;
        }  else if (symbolName === SPECIAL_SYMBOL_NAMES.XH) {
            textureName = "Xhole/xhole_00004";
        } else if (symbolName.indexOf("M") > -1) {
            textureName = symbolName + "/" + (nameHelper === "sipia" ? "sfs" : nameHelper).toUpperCase() + "_" + symbolName + "/" + nameHelper + blur;
        } else if (symbolName.indexOf("L") > -1) {
            textureName = symbolName + "/" + symbolName + "_Assets/" + nameHelper + blur;
        }

        return (KennethMustDie.assetLoader.getTextures(textureName)[0]);
    }
}